import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

const expiryCard = EntityCardBlueprint.make({
  name: 'entity-expiry-card',
  params: {
    loader: async () => {
      const { ExpiryCard } = await import('./ExpiryCard');
      return <ExpiryCard />;
    },
    filter: entity =>
      Boolean(entity.metadata.annotations?.['cleanup.avantpage.dev/expires-at']),
    type: 'info',
  },
});

export const entityExpiryCardModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [expiryCard],
});
